import { Box, Typography } from '@mui/material';
import styles from './JobBoard.module.scss';
import classNames from 'classnames/bind';
import { useAppDispatch, useAppSelector } from '~/redux/hooks';
import { BaseBoard } from '~/components/common';
import { ColumnType, ItemChangeProps } from '~/components/common/base-board/BaseBoard';
import { handleApiError, notify } from '~/utils/helper';
import { PERMISSIONS } from '~/utils/constants/permission';
import usePermission from '~/hooks/usePermission';
import JobBoardCard from './components/JobBoardCard';
import { handleUpdateJob } from '~/thunks/job/jobThunk';
import { useTranslation } from 'react-i18next';

const cx = classNames.bind(styles);

const JobBoard = () => {
  const { jobsBoard } = useAppSelector((state) => state.job);

  const permission = usePermission();
  const dispatch = useAppDispatch();
  const { t } = useTranslation('admin/job');
  const renderColumnComponent = (data: ColumnType) => {
    return (
      <Typography
        variant='h6'
        gutterBottom
        className={cx('container-tittle')}
        style={{
          color: data.color,
          backgroundColor: data.backgroundColor,
        }}
      >
        {data.name}
      </Typography>
    );
  };

  const handleItemChange = async (item: ItemChangeProps) => {
    try {
      await dispatch(
        handleUpdateJob({
          id: Number(item.itemId),
          params: {
            job: {
              position: Number(item.itemPosition),
              statusId: item.columnId,
            },
          },
        })
      ).unwrap();
      notify('success', t('editSuccess', { ns: 'admin/common' }));
    } catch (e: any) {
      handleApiError(e);
    }
  };

  return (
    <Box className={cx('JobBoardContainer')}>
      <BaseBoard
        data={jobsBoard}
        renderColumn={renderColumnComponent}
        renderItem={(item) => <JobBoardCard job={item} />}
        onItemChange={handleItemChange}
        columnClassName={'h-[calc(100vh-350px)]'}
        disabled={!permission[PERMISSIONS.project_edit]}
      />
    </Box>
  );
};

export default JobBoard;
